export default __webpack_public_path__ + "assets/images/c957659191fbe2fcd3852399989bd7b1.svg";